// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  oauthApiUrl: 'https://api-staging.eyefinity.com',
  openIdUrl: 'https://api-staging.eyefinity.com/idp/userinfo.openid',
  oauthClientId: 'eyefinity-elab-spa-ui',
  requiredAdGroups: [],
  oauthScopes:
    'read:laborder openid profile auth_ecp write:laborder read:reference.lens lab_view read:vc.reference.frame read:ef.labs read:ef.providers provider_view read:ef.supplychain write:ef.supplychain write:ef.contactus',
  oauthRedirectUrl: 'https://elab-staging.eyefinity.com/',
  apiBaseUrl: 'https://api-staging.eyefinity.com',
  elabWebsiteBaseUrl: 'https://portal-staging.eyefinity.com/secure-elab',
  elearnWebsiteBaseUrl: 'https://portal-staging.eyefinity.com/secure-elearn',
  eInsuranceWebsiteBaseUrl: 'https://portal-staging.eyefinity.com/secure-einsurance',
  ecpCentralWebsiteBaseUrl: 'https://portal-staging.eyefinity.com/secure-ecp-central',
  welcomeUrl: 'https://portal-staging.eyefinity.com/secure-welcome',
  modernEclaimWebsiteBaseUrl: 'https://eclaim-stg.eyefinity.com/secure/eInsurance',
  claimResourceCenterBaseUrl: 'https://secureb-st.eyefinity.com/elearn/Page.do?key=claimresource',
  privacySecurityPolicyFooterLink: 'https://www.eyefinity.com/legal/privacy-and-security-policy',
  customerCareInfoLink: 'https://www.eyefinity.com/resource/support/contact-us/contact-info.html',
  customerCareFooterLink: 'https://www.eyefinity.com/resource/support/contact-us.html',
  systemRequirementsFooterLink: 'https://www.eyefinity.com/legal/system-requirements.html',
  termsConditionsFooterLink: 'https://www.eyefinity.com/legal/terms-and-conditions-of-use.html',
  noticeOfPrivacyPolicyFooterLink: 'https://www.eyefinity.com/legal/notice-of-privacy-practices',
  bAAFooterLink: 'https://www.eyefinity.com/legal/provider-business-associate-agreement.html',
  eyefinityBaseLink: 'https://www.eyefinity.com',
  cookiesToRetain: ['INFOCUS', 'GOTO_URL', 'LOGON_TYPE'],
  logoutRedirectUrl: 'https://portal-staging.eyefinity.com/secure-welcome/logout-user',
  classicEyefinity: 'https://secureb-st.eyefinity.com/home/',
  handoff: 'https://portal-staging.eyefinity.com/secure-oven/handoff?url={0}',
  cloudTarget: 'cloud-vspvision',
  vspProvidersEndPoint: 'https://api-staging.vspglobal.com/provider-web/externalservicelocation',
  oppProvidersEndPoint: 'https://api-staging.eyefinity.com/eyefinity-providers/providers',
  feedbackEndPoint: 'https://api-staging.eyefinity.com/eyefinity-contactus/feedback',
  dynaTraceUrl: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf63206omp/2c7c6a16627dd739_complete.js',
  authEcpUrl: 'https://api-staging.vspglobal.com/auth-ecp/userinfolite',
  frameDisposition: 'https://api-staging.eyefinity.com/alacpt-client-fulfillment/frameboard/disposition',
  fulfillmentReplacementOrder: 'https://api-staging.eyefinity.com/alacpt-client-fulfillment/frameboard/replacementorder',
  fulfillmentDropShipOrder: 'https://api-staging.eyefinity.com/alacpt-client-fulfillment/frameboard/dropshiporder',
  fulfillmentParticipatingLabs: 'https://api-staging.eyefinity.com/alacpt-client-fulfillment/frameboard/participatinglabs',
  walkmeUrl: 'https://cdn.walkme.com/users/6e072cd3dd7647aabff33cbd89488f9a/test/walkme_6e072cd3dd7647aabff33cbd89488f9a_https.js',
  changePassword: 'https://sso-stg.vspvision.com/ext/pwdchange/Identify?AdapterId=VspEcpAdapter&pf.username=',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
